import React from 'react';

function KpiCard({ label, value, color, icon }) {
  return (
    <div
      className="relative bg-white rounded-[12px] p-3 border overflow-hidden transition-all duration-200 hover:-translate-y-[3px]"
      style={{
        borderColor: '#ddd6c6',
        boxShadow: '0 2px 16px rgba(8,17,31,.07)',
        background: `linear-gradient(135deg, ${color}06 0%, #ffffff 70%)`,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.boxShadow = `0 4px 20px ${color}20`; }}
      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 16px rgba(8,17,31,.07)'; }}
    >
      {/* Watermark icon */}
      <span className="absolute top-2.5 right-3 text-[28px] opacity-[0.07] select-none pointer-events-none">{icon}</span>
      <div className="text-[10px] uppercase tracking-[1.5px] font-semibold text-[#7a7060] mb-1">{label}</div>
      <div className="text-[24px] leading-none font-bold" style={{ color, fontFamily: "'Cormorant Garamond', serif" }}>{value}</div>
      {/* Bottom accent bar */}
      <div className="absolute bottom-0 left-0 right-0 h-[3px]" style={{ background: `linear-gradient(90deg, ${color}, ${color}60)` }} />
    </div>
  );
}

export default KpiCard;
